import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useOthersStore } from "../../../store/othersStore.js";


import Navbar from "./navbar";

import "./styles.css";

const DashboardLayout = ({ children }) => {
  const { getAuthors, getCategories } = useOthersStore();

  useEffect(() => {
    getAuthors();
    getCategories();
  }, [getAuthors, getCategories]);

  return (
    <div className="dashboard-layout">
      <Navbar />
      <div className="content">
        <Outlet />
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;








